var _path, _path2, _circle, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadFile(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.36 6H25l-4.995-5v4.643c-.035.178.107.321.284.357h.07z",
    fill: "#C8C8C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.818 7.8a1.836 1.836 0 0 1-1.852-1.857V0H8.222A2.232 2.232 0 0 0 6 2.229v21.543C6 24.997 7 26 8.222 26h15.556A2.232 2.232 0 0 0 26 23.772V7.8h-6.182z",
    fill: "#C8C8C8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 13.5,
    r: 6.5,
    fill: "#6467EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.428 13.5c0 .197-.16.357-.357.357H6.857v3.215c0 .196-.16.357-.357.357a.358.358 0 0 1-.357-.357v-3.214H2.928a.358.358 0 0 1-.357-.358c0-.196.161-.357.357-.357h3.215V9.93c0-.197.16-.357.357-.357.196 0 .357.16.357.357v3.214h3.214c.197 0 .357.16.357.357z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 9.722a.208.208 0 0 0-.207.207v3.364H2.929a.208.208 0 0 0-.208.207c0 .114.094.207.208.207h3.364v3.365c0 .113.093.207.207.207a.208.208 0 0 0 .207-.207v-3.365h3.364a.208.208 0 0 0 .207-.207.208.208 0 0 0-.207-.207H6.707V9.93a.208.208 0 0 0-.207-.207zm-.507.207a.508.508 0 0 1 1.014 0v3.064h3.064a.508.508 0 0 1 0 1.014H7.007v3.065a.508.508 0 0 1-1.014 0v-3.065H2.929a.508.508 0 0 1 0-1.014h3.064V9.93z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload-file.906ed85c.svg";
export { ForwardRef as ReactComponent };